import React from 'react';
import PropTypes from 'prop-types';
import { makeCancelable } from '../../../../../widget/utils/make-cancelable-promise';
export class AccessibleSocialButton extends React.Component {
    constructor(props) {
        super(props);
        this.setAccessibilityStatus = (isAccessible) => {
            if (!this.iframeNode) {
                return;
            }
            this.iframeNode.setAttribute('tabindex', isAccessible ? 0 : -1);
            if (isAccessible) {
                this.iframeNode.removeAttribute('aria-hidden');
                return;
            }
            this.iframeNode.setAttribute('aria-hidden', true);
        };
        this.saveContainerNode = (node) => {
            this.containerNode = node;
        };
        this.attachScriptPromise = null;
    }
    componentDidMount() {
        const { attachScript, initButton, title } = this.props;
        this.attachScriptPromise = makeCancelable(attachScript());
        this.attachScriptPromise.promise
            .then(() => initButton(this.containerNode))
            .then(() => {
            this.iframeNode = this.containerNode.querySelector('iframe');
            this.setAccessibilityStatus(this.props.isAccessible);
            if (title) {
                this.iframeNode.setAttribute('title', title);
            }
        });
    }
    componentWillUnmount() {
        this.attachScriptPromise.cancel();
    }
    UNSAFE_componentWillReceiveProps({ isAccessible }) {
        if (isAccessible !== this.props.isAccessible && this.iframeNode) {
            this.setAccessibilityStatus(isAccessible);
        }
    }
    render() {
        const { children } = this.props;
        return React.createElement("div", { ref: this.saveContainerNode }, children);
    }
}
AccessibleSocialButton.propTypes = {
    isAccessible: PropTypes.bool,
    attachScript: PropTypes.func,
    initButton: PropTypes.func,
    children: PropTypes.node,
    title: PropTypes.string,
};
//# sourceMappingURL=accessible-social-button.js.map